import React from 'react';
import { Percent } from 'lucide-react';

interface MatchIndicatorProps {
  percentage: number;
}

export function MatchIndicator({ percentage }: MatchIndicatorProps) {
  // Color classes based on match percentage
  const getColorClasses = () => {
    if (percentage >= 80) return 'bg-[#373737] border-[#d8f477] text-[#d8f477]';
    if (percentage >= 60) return 'bg-[#373737] border-yellow-400 text-yellow-400';
    return 'bg-[#373737] border-gray-400 text-gray-400';
  };

  return (
    <div className={`flex items-center gap-0.5 px-2 py-0.5 rounded-full border border-dashed ${getColorClasses()}`}>
      <Percent className="h-3 w-3" />
      <span className="text-xs font-medium">{percentage}% Match</span>
    </div>
  );
}